import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router";
import style from './transferWoundAssessment.module.scss'
import { useNavigate, useParams } from 'react-router-dom';
import {patientAssessmentAsync, detailAssessmentAsync, transferWoundSuccessReeval, setTransferWoundSuccess, 
    optionTypeAsync, patientAssessmentHistoryAsync, getTransferCallBackListAsync, setPatients, setResMsgState,
    getFacilityDataAsyncForPatients, checkCustomerAsync,setWoundAssessment,setAssessmentHistory, patientUpdateAsync, patientRiskAssessmentAsync,
    setPatientListLastVal,setDetailViewData, patientDetailsAsync, deletePatientListAsync, setPatientLoad} from '../../../app/patientSlice'
import { fullMonthFormatDate, allNullCheck, assessmentStageGetterMove, dateOfBirthDate, getActivePageTransferData, getFacilityLabelTransfer, getSearchValueTransferData } from '../../../utils';
import { deleteAsync, deleteParentChildAsync } from '../../../app/appSlice';
import {Pagination} from '../../secondary/Pagination'
import { format } from 'date-fns'
import { Button, SelectBox } from '../../primary';
import {PATIENT_GENDER, LIST_VIEW_LIMIT, PATIENT, DELETE_PARENT_ASSESSMENT, DELETE_HISTORY_ASSESSMENT, SUCCESS_STATUS, DELETE_CHILD_ASSESSMENT, DEFAULT_ASSESSMENT_LIMIT_OFFSET} from '../../../constants'
import Loader from '../../../static/images/spinner.svg';
import LogoImage from '../../../static/images/measurmenttest.jpg';
import pictureIcon from '../../../static/images/picture-icon-default.png'
import searchIcon from '../../../static/images/search-icon.svg';
import { useAdminView } from '../../../hooks/useAdminView';
import { getHistoryCauseText } from '../../../utils/getHistoryCauseText';

const TransferWoundAssessment = () => {
    const navigate = useNavigate();
    const location = useLocation();
const { patientId } = useParams();
const { assessmentId } = useParams();
const dispatch = useDispatch();
const adminPageYes = location.state;
const isAdminView = useAdminView();
window.onload = function() {
    dispatch(detailAssessmentAsync({ patientId, assessmentId })) 
    // dispatch(patientAssessmentAsync(patientId))   
    dispatch(setTransferWoundSuccess(null));  
    dispatch(optionTypeAsync('historycause'))
    setSearchKey('')
}
useEffect(()=>{
    dispatch(detailAssessmentAsync({ patientId, assessmentId }))
    // dispatch(patientAssessmentAsync(patientId))   
    dispatch(setTransferWoundSuccess(null));  
    dispatch(optionTypeAsync('historycause'))
    setSearchKey('')
},[])

/* Get state with the Individual patient data */
const detailAssessment = useSelector(state => state.patient.detailAssessment);
const userDetails = useSelector(state => state.user);
const transferFrom = useSelector((state) => state.patient.transferFrom);
const [allAssessmentState, setAllAssessmentState] = useState(false)
const [offSet, setOffSet] = useState(0)
//For right side list call the API
useEffect(()=>{  
    rightSideListFectch();
        if(adminPageYes && detailAssessment?.reEvalSequence > 0){
            dispatch(patientAssessmentHistoryAsync(patientId, assessmentId));
            setAllAssessmentState(true)
            setTinyDelyLeft(true)
        }
        else{
            setAllAssessmentState(false)
            setTinyDelyLeftAllAssessment(true)        
        }          
},[detailAssessment])

//For right side list call the API
const rightSideListFectch = () => {   
    const payload = {};    
    payload['url'] = PATIENT
    payload['method'] = 'Get'
    payload['queryParam'] = {search:'', facilityNumber:'',customerNumber: userDetails?.customerNumber, NE1ID: patientId, offSet: offSet, limit: LIST_VIEW_LIMIT, pagetype: "patient",sort: ''}
    payload['setMethod'] = setPatients;
    dispatch(getTransferCallBackListAsync(payload))
}


const patientData = useSelector(state => state.patient.detailViewData)
// const woundAssessments = useSelector(state => state.patient.woundAssessments);
const assessmentHistoryData = useSelector(state => state.patient.assessmentHistory);
const historyCause = useSelector(state => state.patient.historyCause);
const woundClassificationOptions = useSelector(state => state.patient.woundClassificationOptions)
// const woundAssessmentsAnatomyList = useSelector(state => state.patient.woundAssessmentsAnatomyList);//right side card list



const[assessmentHistoryState, setAssessmentHistoryState] = useState([])
useEffect(()=>{
    let assessmentLists = [];  
        assessmentHistoryData?.followuphistory?.map((item)=>{               
            return(
                setAssessmentHistoryState(item)
            )
        }) 
},[assessmentHistoryData, allAssessmentState])

//loader when singale assessments
const [tinyDelyLeft, setTinyDelyLeft] = useState(false)
useEffect(()=>{
    let getloadValue = detailAssessment !== undefined ? true : false;
    if(getloadValue && !allAssessmentState){
        setTimeout(()=>{
            setTinyDelyLeft(true)
        }, 2500)    
      } 
},[!allAssessmentState, detailAssessment])
//loader when multiple assessment
const [tinyDelyLeftAllAssessment, setTinyDelyLeftAllAssessment] = useState(false)
useEffect(()=>{
    let getloadValue = assessmentHistoryState?.assessments !== undefined ? true : false;
    if(getloadValue && allAssessmentState){
        setTimeout(()=>{
            setTinyDelyLeftAllAssessment(true)
        }, 2500)    
      }
},[allAssessmentState, assessmentHistoryState])

const transferData = useSelector(state => state.patient.transferData)
//Loader set to until api getting response for right side card
const [tinyDelay, setTinyDelay] = useState(false)
useEffect(()=>{
  let getloadValue = transferData?.patients !== undefined ? true : false;
  if(getloadValue){
    setTimeout(()=>{
      setTinyDelay(true)
    }, 3500)    
  } 
  else{
    if(detailAssessment !== undefined){
    setTimeout(()=>{
        setTinyDelay(true)
      }, 2000) 
    }
  }   
// setTinyDelay(true)
 })

const [mergeAssessment, setMergeAssessment] = useState([])
window.onload = function() {
    setMergeAssessment([detailAssessment])
    setCountMoved(0)
    setDropHereState(true) 
    setGetMergingAssessmentId(null)     
}
useEffect(()=>{
    setMergeAssessment([detailAssessment])
    setCountMoved(0)  
    setDropHereState(true)
    setGetMergingAssessmentId(null)
},[])

//Drag functionality
const [dropHereState, setDropHereState] = useState(true)
const drag = (ev) => {
    ev.dataTransfer.setData("div", ev.target.id);  
    setDropHereState(true)     
}

const allowDrop = (ev, id) => {  
    ev.preventDefault();
    setDropHereState(true)
}
  
const [movedSuccess, setMovedSuccess] = useState(false)
const [countMoved, setCountMoved] = useState(0)
const [firstConent, setFirstContent] = useState(false)
const [removeFlag, setremoveFlag] = useState(false)
const [getMergingAssessmentId, setGetMergingAssessmentId] = useState(null);
//Drop Success functionality
const drop = (ev, id) => {
    ev.preventDefault();
    var data = ev.dataTransfer.getData("div");
    if(id !== undefined){
        ev.target.appendChild(document.getElementById(data));
        setGetMergingAssessmentId(id)
        if(undoChangeClick){
            ev.target.removeChild(document.getElementById(data));
        }                
        setLeaveHover(false)
        setMovedSuccess(true)
        if(firstConent===true){
            setremoveFlag(true)
        }
        if(firstConent===false){
            setremoveFlag(false)
        }             
    }  
    if(id === undefined){
        setDropHereState(false)
        setGetMergingAssessmentId(null)
    } 
}

// hover list functionality
const [onHoverList, setOnHoverList] = useState()
const hoverRightList = (e, index) => {
    setOnHoverList(index)
    setLeaveHover(true)
}
const [leaveHover, setLeaveHover] = useState(false)
const hoverLeaveRIghtList = (index) => {
    setLeaveHover(false)
}
//after successfully merged got confirmation
const [giveConfirmation, setGiveConfirmation] = useState(false)
const clickConfirmChange = (ev) => {
    if(movedSuccess && getMergingAssessmentId !== null) {
        setGiveConfirmation(true)
    }
}
//after successfull merge process navigate to woundassessment screen
const [navigatePmtScreen, setNavigatePmtScreen] = useState(false)
useEffect(()=>{
    if(giveConfirmation && getMergingAssessmentId !== null) {
        setTimeout(()=>{
            setNavigatePmtScreen(true)
        }, 2500)        
    }      
},[giveConfirmation, getMergingAssessmentId !== null])

useEffect(()=>{
    if(navigatePmtScreen){
        let payload = {
            "targetPatientId" : getMergingAssessmentId, 
            "mergePatientNE1Id" : patientId,
            "mergingAssessmentId": assessmentId,
            transfer: transferFrom ?? "assessment_level "
        }
        dispatch(transferWoundSuccessReeval(payload, navigate))
    }
},[navigatePmtScreen])
//Undo single assessment parent/child functionality
const [undoChangeClick, setUndoChangeClick] = useState(false)
const [undoChangeValue, setUndoChangeValue] = useState([])
const clickUndoChange = (ev) => {
    if(undoChangeClick){
        setUndoChangeClick(false)
    } 
    if(!undoChangeClick){
        setUndoChangeClick(true)
    }
    setremoveFlag(false)  
    setFirstContent(false)
    setGiveConfirmation(false)
    setNavigatePmtScreen(false)
    setCountMoved((prevValue) => prevValue + 1)
    setMovedSuccess(false)
    setGetMergingAssessmentId(null)
    setUndoChangeValue([detailAssessment])
}

//Undo more than one assessment functionality
const [undoChangeClickAllAssessment, setUndoChangeClickAllAssessment] = useState(false)
const [undoChangeValueAllAssessment, setUndoChangeValueAllAssessment] = useState([])
const clickUndoChangeAllAssessment = (ev) => {
    if(undoChangeClickAllAssessment){
        setUndoChangeClickAllAssessment(false)
    } 
    if(!undoChangeClickAllAssessment){
        setUndoChangeClickAllAssessment(true)
    }
    setremoveFlag(false)  
    setFirstContent(false)
    setGiveConfirmation(false)
    setNavigatePmtScreen(false)
    setCountMoved((prevValue) => prevValue + 1)
    setMovedSuccess(false)
    setGetMergingAssessmentId(null)
    setUndoChangeValueAllAssessment([assessmentHistoryState])
}

const statusBadg = {
    'pendingassessment': <span className={`pt-2 pb-2 ${style.assess_status} ${style.pending_assess}`}>Pending Assessment</span>,
    'reviewed': <span className={`pt-2 pb-2  ${style.assess_status} ${style.reviewed}`}>Reviewed</span>,
    'pendingreview': <span className={`pt-2 pb-2 ${style.assess_status} ${style.pending_review}`}>Pending Review</span>,
    'signedlocked': <span className={`pt-2 pb-2 ${style.assess_status} ${style.signed_locked}`}>Signed &#38; Locked</span>
}

const detaileView = (data) => {
    navigate('/patients/' + patientId + '/assessment/' + data);   
}
const assessmentStageGetter = (data) => {
    return assessmentStageGetterMove(data)
}

 /* Trigger ad doc overlay close*/
  const leaveDropAction = useRef(null);
  
  // Click event listener and calling handleClickOutside function if we click outside
  useEffect(() => {
      document.addEventListener('mouseout', handleClickOutside);
      return () => document.removeEventListener('mouseout', handleClickOutside);
  });
  const handleClickOutside = (e) => {
      if (!movedSuccess && leaveDropAction !== null && leaveDropAction.current && !leaveDropAction.current.contains(e.target)) {
        //   setAddFile(false);
        setDropHereState(false)
        setLeaveHover(false)
        setMovedSuccess(false)
      }
  };






//   const userDetails = useSelector(state => state.user);
 
  const patientListLastVal = useSelector(state => state.patient.patientListLastVal);
  
  useEffect(() => {
    if (userDetails?.role !== "MedlineAdministrator"&&userDetails?.customerSettings?.ne1Wms === 0) {  
      navigate('/learnMore'); 
    }
  if(userDetails && userDetails.customerSettings &&userDetails?.customerSettings?.ne1Wms === 0){
    if(userDetails?.role==="ExternalStandardUser" || userDetails?.role==="ExternalAdministrator" || userDetails.role === "ExternalNE1WoundExpert" || userDetails.role === "ExternalNE1Review" || userDetails.role === "ExternalNE1Assesment"){
      navigate('/learnMore')
    }  
  }
  }, [userDetails]) 

  const [selectedFacility, setSelectedFacility] = useState(patientListLastVal?.selectedFacility?patientListLastVal?.selectedFacility:'')
  const patientsList = useSelector(state => state.patient.patients);
  const accessError = useSelector(state => state.app.accessError)

  const [customerNumber, setCustomerNumber] = useState(patientListLastVal?.customerNumber?patientListLastVal?.customerNumber:userDetails?.customerNumber);

  useEffect(() => {
    dispatch(setResMsgState({}));
    const defaultFacilityNumber = {}
    defaultFacilityNumber['customerNumber'] = customerNumber;
    dispatch(getFacilityDataAsyncForPatients(defaultFacilityNumber));
    if (!isAdminView) {
      dispatch(checkCustomerAsync(defaultFacilityNumber))
    } else {
        dispatch(checkCustomerAsync(defaultFacilityNumber))
      setSelectedFacility(patientListLastVal?.selectedFacility?patientListLastVal?.selectedFacility:'')
    }
    if (document.getElementById('facility')) {
      document.getElementById('facility').value = patientListLastVal?.selectedFacility?patientListLastVal?.selectedFacility:'';
    }
    if (document.getElementById('search')) {
      document.getElementById('search').value = patientListLastVal?.searchKey?patientListLastVal?.searchKey:'';
    }
  }, [dispatch])
  /* Get state with the Individual patient data */
//   const patientData = useSelector(state => state.patient.detailViewData)  
  const getFacilities = useSelector(state => state.patient.newFacilitiesData);
  const [facilityNumberOption, setFacilityNumber] = useState('');
  
  const getAssessments = (patientId, param) => dispatch(patientAssessmentAsync(patientId, param));

  const getAssessmentHistory = (assessmentId) =>
    dispatch(patientAssessmentHistoryAsync(patientId, assessmentId));

  //Parent Level Delete Assessment
  const deleteAssessment = (assessmentId) =>{ 
    const payload = {      
      'patientId': patientId,
      'assessmentId': `${assessmentId}`
    }
    const deleteURL = DELETE_PARENT_ASSESSMENT;
    dispatch(setWoundAssessment("reset"));
    dispatch(deleteParentChildAsync(payload, deleteURL, patientAssessmentAsync))
  }

//   const assessmentHistoryData = useSelector(state => state.patient.assessmentHistory);
  const [childLevelDelete, setChildLevelDelete] = useState(false)

  //Child Level Delete Assessment
  const deleteAssessmentChildLevel= (assessmentId) => {   
    const finalArrValue = parseInt(assessmentHistoryData?.followuphistory?.map(data=>data?.assessments?.filter(item=>item.id!==assessmentId))?.map(item=>item[0]?.id))
    const payload = {      
      'patientId': patientId,
      'assessmentId': assessmentId
    }
    const deleteURL = DELETE_CHILD_ASSESSMENT;   
    dispatch(setAssessmentHistory({}));  
    dispatch(deleteParentChildAsync(payload, deleteURL, patientAssessmentAsync, patientAssessmentHistoryAsync, finalArrValue))
    setChildLevelDelete(true)
  }
 
  // const deleteSuccessAPI = (getAssessmentId) =>{
  //   const finalArrValue = parseInt(assessmentHistoryData?.followuphistory?.map(data=>data?.assessments?.filter(item=>item.id!==getAssessmentId))?.map(item=>item[0]?.id))
  //   getAssessmentHistory(finalArrValue) 
  // }

  const deleteHistoryAssessment = (assessmentId, historyAssessmentId) =>
    dispatch(deleteAsync(DELETE_HISTORY_ASSESSMENT, patientId, assessmentId, historyAssessmentId));

  /* Dispatch update patient data */

  const updatePatientData = (data) => dispatch(patientUpdateAsync(data))
  const getRiskAssessments = () => dispatch(patientRiskAssessmentAsync(patientId));
//   const mergeWoundProcessSuccess = useSelector(state => state.patient.mergeNavigateSuccess)


  const [detailsRow, SelectedRow] = useState(false)
  const [searchKey, setSearchKey] = useState(patientListLastVal?.searchKey?patientListLastVal?.searchKey:'')
  const [activePage, setActivePage] = useState(1);
//   const [offSet, setOffSet] = useState(0)
  let [sortType, setSortType] = useState('')
  /* Get Patients Details */

//   useEffect(() => {
//     setCustomerNumber(patientListLastVal?.customerNumber?patientListLastVal?.customerNumber:userDetails?.customerNumber)
//   }, [location])

  useEffect(() => {
    let optionData = [];
  (getFacilities?.data) && getFacilities?.data?.facilities.map((value, index) => {//NOSONAR
    let stateTrue = true;
    optionData.push({ value: getFacilityLabelTransfer(value), key: value.facilityNumber })
    })//NOSONAR
    setFacilityNumber(optionData)
     if (document.getElementById('facility')) {
       document.getElementById('facility').value = patientListLastVal?.selectedFacility?patientListLastVal?.selectedFacility:'';
     }
     if (document.getElementById('search')) {
       document.getElementById('search').value = patientListLastVal?.searchKey?patientListLastVal?.searchKey:'';
     }
    }, [getFacilities])
  const getPatientList = (facilityNumber,searchKeys) => {
    const listPayLoad = {};
    listPayLoad['url'] = PATIENT
    listPayLoad['method'] = 'Get'
    listPayLoad['queryParam'] = {search:searchKeys===''?'': patientListLastVal?.searchKey?patientListLastVal?.searchKey:'', facilityNumber:facilityNumber===''?'':facilityNumber?facilityNumber:patientListLastVal?.selectedFacility?patientListLastVal?.selectedFacility:selectedFacility,customerNumber: patientListLastVal?.customerNumber?patientListLastVal?.customerNumber:userDetails?.customerNumber, NE1ID: patientId, offSet: offSet, limit: LIST_VIEW_LIMIT, pagetype: "patient",sort: (sortType)?sortType:''}
    listPayLoad['setMethod'] = setPatients
    dispatch(getTransferCallBackListAsync(listPayLoad))
    dispatch(setPatientLoad(true))
     if (document.getElementById('facility')) {
       document.getElementById('facility').value = patientListLastVal?.selectedFacility?patientListLastVal?.selectedFacility:'';
     }
     if (document.getElementById('search')) {
       document.getElementById('search').value = patientListLastVal?.searchKey?patientListLastVal?.searchKey:'';
     }
  }


  useEffect(() => {
    setSortType('')
    setSearchKey('')
    setSelectedFacility(patientListLastVal?.selectedFacility?patientListLastVal?.selectedFacility:'')
    setOffSet(0)
    setActivePage(1)
    if (document.getElementById('facility')) {
      document.getElementById('facility').value = patientListLastVal?.selectedFacility?patientListLastVal?.selectedFacility:'';
    }
    if (document.getElementById('search')) {
      document.getElementById('search').value = patientListLastVal?.searchKey?patientListLastVal?.searchKey:'';
    }
    if(customerNumber){
      const setLast={...patientListLastVal,searchKey:patientListLastVal?.searchKey,customerNumber:customerNumber }
      dispatch(setPatientListLastVal(setLast))
    }
  }, [dispatch, isAdminView, customerNumber, getFacilities]);

  const showFixedColumn = !!patientsList?.data && !!patientsList?.data?.patients?.length
  let columns = [];
  (isAdminView) ?
    columns = [
      {
        Header: 'MRN # ',
        accessor: 'mrn',
        disableSortBy: false,
        fixedColumn: showFixedColumn,
        fixedWidth: '200px'
      },
      {
        Header: 'First name',
        accessor: 'firstName',
        fixedColumn: showFixedColumn,
        fixedWidth: '250px'
      },
      {
        Header: 'Last name',
        accessor: 'lastName',
        fixedColumn: showFixedColumn,
        fixedWidth: '255px'
      },
      {
        Header: 'Gender',
        accessor: 'gender'
      },
      {
        Header: 'DOB',
        accessor: 'dob',
      },
      {
        Header: 'Age',
        accessor: 'age',
      },
      {
        Header: 'Primary group',
        accessor: 'customerNumber',
      },
      {
        Header: 'Facility/Location',
        accessor: 'facilityName'
      },
      {
        Header: 'Admission date',
        accessor: 'admissionDate'
      },
      {
        Header: 'Discharge date',
        accessor: 'dischargeDate'
      },
      {
        Header: 'Phone',
        accessor: 'phone'
      }
      ,
      {
        Header: 'Address',
        accessor: 'addressLines'
      },
      {
        Header: 'City',
        accessor: 'city'
      },
      {
        Header: 'State',
        accessor: 'state'
      },
      {
        Header: 'Zip',
        accessor: 'zipCode'
      }
    ]
    :
    columns = [
     /* {
        Header: 'NE1 ID',
        accessor: 'ne1Id',
        disableSortBy: false,
        fixedColumn: showFixedColumn
      },*/
      {
        Header: 'MRN # ',
        accessor: 'mrn',
        disableSortBy: false,
        fixedColumn: showFixedColumn,
        fixedWidth: '200px'
      },
      {
        Header: 'First name',
        accessor: 'firstName',
        fixedColumn: showFixedColumn,
        fixedWidth: '200px'
      },
      {
        Header: 'Last name',
        accessor: 'lastName',
        fixedColumn: showFixedColumn,
        fixedWidth: '205px'
      },
      {
        Header: 'Gender',
        accessor: 'gender'
      },
      {
        Header: 'DOB',
        accessor: 'dob',
      },
      {
        Header: 'Age',
        accessor: 'age'
      },
      {
        Header: 'Primary group',
        accessor: 'customerNumber',
      },
      {
        Header: 'Facility/Location',
        accessor: 'facilityName'
      },
      {
        Header: 'Admission date',
        accessor: 'admissionDate'
      },
      {
        Header: 'Discharge date',
        accessor: 'dischargeDate'
      }
    ]


  /* If url changes, hide the detail view */
//   useEffect(() => {
//     SelectedRow(false)
//     return () => {
//       SelectedRow(false)
//     };
//   }, [location])

  /* If no patient id in url, dispatch empty data */
  useEffect(() => {
    if (!patientId) {
      dispatch(setDetailViewData({}))
    }
  }, [patientId, dispatch])


  /* If patient id exists display detail view */
  useEffect(() => {

    if (patientId) {
      //dispatch(optionTypeAsync('reasonforvisit'));
     // dispatch(optionTypeAsync('insurancepayer'));
      //dispatch(optionTypeAsync('comorbidcondition'));
      /* Fetch data using parameter from url */
      dispatch(patientDetailsAsync(patientId))
      /* Flag to display detail view page */
      SelectedRow(true)
      dispatch(optionTypeAsync('historycause'));
      /*dispatch(optionTypeAsync('humananatomy'));
      
      dispatch(optionTypeAsync('pihistory'));
      dispatch(optionTypeAsync('woundage'));
      dispatch(optionTypeAsync('phototype'));
      dispatch(optionTypeAsync('documentationtype'));*/
    }    
  }, [patientId, dispatch])

  const getSelectedRowData = (data) => {
    /* If user clicks the row redirect to detail view page by attaching MRN to the url */
    if (data) {
      isAdminView ? navigate('/admin/patients/' + data.ne1Id) : navigate('/patients/' + data.ne1Id);
    }
  }
  const handleBack = () => {
    SelectedRow(false)
  }

  // search list
const getSearchValue = (event) => { 
    if(event === ''){
        const setLast={...patientListLastVal,searchKey:'' }
        dispatch(setPatientListLastVal(setLast))
        setOffSet(0)
        setActivePage(1)
        setSearchKey('')
        setSortType('')
        getPatientList('','');
    }
    else{  
        setOffSet(0)
        setActivePage(1)
        setSearchKey(event)
        const setLast={...patientListLastVal,searchKey: event }
        dispatch(setPatientListLastVal(setLast))
        if (document.getElementById('facility')) {
            dispatch(setPatientLoad(true))
            getSearchValueTransferData(event, PATIENT, customerNumber, offSet, LIST_VIEW_LIMIT, setPatients, setSearchKey, dispatch, getTransferCallBackListAsync, isAdminView, selectedFacility,sortType, patientId)
        }                   
    } 
        
}    
    
const getShowClearX = (event) => {  
    if(event.target.value === ''){
    setShowClearX(false)
    if(document.getElementById('searchurlInput')){
    document.getElementById('searchurlInput').value = null ;
    }  
    const setLast={...patientListLastVal,searchKey:'' }
    dispatch(setPatientListLastVal(setLast))
    setOffSet(0)
    setActivePage(1)
    setSearchKey('')
    setSortType('')
    getPatientList('',''); 
    }else {    
    setShowClearX(true)                       
    }  
};

const ClearData = (value) => { 
    if(document.getElementById('searchurlInput')){
    document.getElementById('searchurlInput').value = null ;
    }  
    const setLast={...patientListLastVal,searchKey:'' }
    dispatch(setPatientListLastVal(setLast))
    setOffSet(0)
    setActivePage(1)
    setSearchKey('')
    setSortType('')
    getPatientList('','');    
    }

  const [showClearX, setShowClearX] = useState(searchKey?true:false)
  useEffect(() => {
    if (searchKey) {
      setShowClearX(true)
    }else{
      setShowClearX(false)
      const setLast={...patientListLastVal,searchKey:'' }
        dispatch(setPatientListLastVal(setLast))
        setOffSet(0)
        setActivePage(1)
        setSearchKey('')
        setSortType('')
        getPatientList('','');
    }
  },[searchKey]);

  // pagination
  const getActivePage = (data) => {
    dispatch(setPatientLoad(true))
    setOffSet((((data * LIST_VIEW_LIMIT) - LIST_VIEW_LIMIT) < LIST_VIEW_LIMIT) ? 0 : (data * LIST_VIEW_LIMIT) - LIST_VIEW_LIMIT)
    getActivePageTransferData(data, setActivePage, PATIENT, customerNumber, LIST_VIEW_LIMIT, setPatients, dispatch, getTransferCallBackListAsync, searchKey, isAdminView, selectedFacility,sortType, patientId);
  }
  
  // sorting
  const sortingPayLoad = {};
  sortingPayLoad['url'] = PATIENT
  sortingPayLoad['method'] = 'Get'
  sortingPayLoad['queryParam'] = { facilityNumber:patientListLastVal?.selectedFacility?patientListLastVal?.selectedFacility:selectedFacility,customerNumber: customerNumber, offSet: isNaN(offSet)===true?0:offSet, limit: LIST_VIEW_LIMIT, search: (searchKey) ? searchKey : '', pagetype: "patient", sort: (sortType)?sortType:''}
  if (document.getElementById('facility')) {
    document.getElementById('facility').value = patientListLastVal?.selectedFacility?patientListLastVal?.selectedFacility:'';
  }
  if (document.getElementById('search')) {
    document.getElementById('search').value = patientListLastVal?.searchKey?patientListLastVal?.searchKey:'';
  }
  sortingPayLoad['setMethod'] = setPatients
  sortingPayLoad['setSortType'] = setSortType
  sortingPayLoad['asyncMethod'] = getTransferCallBackListAsync

  /* Get Patients Details Facility Number*/
  const facilityListView = (value) => {
    dispatch(setPatientLoad(true))
    setSortType('')
    setSearchKey('')
    setOffSet(0)
    setActivePage(1)
    if (document.getElementById('search')) {
      document.getElementById('search').value = '';
    }
    if (value || value !== true || value !== false) {
      const setLast={...patientListLastVal,selectedFacility: value,searchKey:'' }
      dispatch(setPatientListLastVal(setLast))
      setSelectedFacility(value)
      getPatientList(value,'');
     
    }
}
  const deleteList = (data) => {
    dispatch(deletePatientListAsync(data))
  }

  const deleteStatus = useSelector(state => state.app.deleteStatus)

  useEffect(() => {
    if (deleteStatus) {
      if (deleteStatus.status === SUCCESS_STATUS) {
        getPatientList();
        if(patientId){
          getAssessments(patientId, DEFAULT_ASSESSMENT_LIMIT_OFFSET);
        }
        
      }
    }
  }, [deleteStatus])

  useEffect(() => {
    if (document.getElementById('facility')) {
      document.getElementById('facility').value = patientListLastVal?.selectedFacility?patientListLastVal?.selectedFacility:'';
    }
    if (document.getElementById('search')) {
      document.getElementById('search').value = patientListLastVal?.searchKey?patientListLastVal?.searchKey:'';
    }
    getPatientList();
  }, []) 
 const [noPage, setNoPage] = useState(false);


    return(
        <div className={`col-12 ${style.mergeWoundPage} px-0`}>
            <div className={`${style.mergewoundWholeSection} col-12 d-flex justify-content-between align-items-center px-0`}>                
                <div className='col-6 pl-0'>   
                    <div className={`col-12 ${style.mergeLeftsideCard} d-flex align-items-center`}>
                        <h3>Drag and drop to move this wound to another Patient </h3>                        
                        <div className={`${style.arrow}`}>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                    <div className='col-12 pl-0'>
                        <div className={`${style.patientCardMain}`}>
                            <div className={`col-12 ${style.patient_details_blk_scroll}`}>
                                <div className={`${style.patient_image} mx-3`}>
                                    <a href={`/admin/patients/${patientId}`} target="_self">
                                        <img src={patientData?.moreInfo?.profilePicture || pictureIcon} alt={`${patientData?.firstName} ${patientData?.lastName}`}/>                    
                                    </a>
                                </div>
                                <div className={`${style.patient_details}`}>
                                    <div className='d-flex align-items-center pb-2'>
                                        <div className={'d-flex align-items-center'} >
                                            <a href={`/admin/patients/${patientId}`} target="_self" className={'d-flex align-items-center'}>
                                                <h4 className="pr-1 mb-0">{`${patientData?.firstName} ${patientData?.lastName}`}</h4>
                                            </a>
                                        </div>
                                        <div className={`verticalCode  ${style.vertical_Code}`}>
                                        </div>    
                                        <p className={`${style.labelSize} pt-1`}><span>{patientData?.age}</span></p>
                                        <div className={`verticalCode  ${style.vertical_Code}`}>
                                        </div>
                                        <p className={`${style.labelSize} pt-1`}><span>{PATIENT_GENDER[patientData.gender ? patientData.gender.toLowerCase() : '']}</span></p>                        
                                        <div className={'mx-4 text-center'}>
                                            <Button
                                                type={"button"}
                                                value={"Diabetic"}
                                                classes={{ className: (patientData?.moreInfo?.diabetic === "1" || patientData?.moreInfo?.diabetic === 1) ?  `btn ${style.btn_custom_with_diabetic}` : 'd-none' }}
                                                id="diabetic"
                                            />
                                        </div>                       
                                    </div>
                                    <div className='d-flex align-items-center'>
                                        <p className={`${style.labelSize}`}><label>MRN #:</label><span>{patientData?.mrn !== null ? patientData?.mrn : "-"}</span></p>
                                        <div className={`verticalCode  ${style.vertical_Code_one}`}>
                                        </div>
                                        <p className={`${style.labelSize}`}><label>DOB:</label><span>{dateOfBirthDate(patientData?.dob)}</span></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>                   
                    {!allAssessmentState && !undoChangeClick && <div className={`col-12 ${style.mergerWoundMain}`} onDrop={(e)=>{drop(e);setFirstContent(false);}} onDragOver={(e)=>allowDrop(e)} id="div1">                                      
                        {!tinyDelyLeft ? <div className={`${'loader'} col-12`}><img src={Loader} alt="loading" /></div>:
                            <div className={`${style.wholeDrag_Undo}`} draggable="true" onDragStart={(e)=>drag(e)} onDragOver={(e)=>allowDrop(e)} id={"drag1"}>
                                <div className={`col-12 ${style.woundTitle} d-flex py-3`}>
                                    <a href={`/patients/${patientData?.ne1Id}/assessment/${assessmentId}`}>
                                        {detailAssessment?.title}
                                    </a>
                                    <span className='ml-auto mr-4'>{statusBadg[detailAssessment?.assessmentStage]}</span>
                                    {/* <span className={`${style.adminPageYesBatch} ml-auto mr-4`}>{adminPageYes ? 'Parent' : 'Child'}</span> */}
                                    <i className={`fas`} style={{fontSize:'20px',color:'#787878',float:'right', marginTop:'-10px'}}>&#xf58e;</i>
                                </div>
                                <div className={`col-12 d-flex ${style.midContent} justify-content-center align-items-center`}>
                                    <div className='col-2 p-0'>
                                        <div className={`${style.woundAssessment_img_parent}`} draggable="false">
                                            <img src={detailAssessment?.picture} alt="wound" className="woundAssessment_wound_img" draggable="false"/>
                                        </div>
                                    </div>
                                    <div className='col-10'>
                                        <div className={`${style.assess_content} pb-3`}>  
                                            <span className={style.assess_content_label}>History/Cause: </span> 
                                            <span className={style.assess_label}>{getHistoryCauseText(detailAssessment?.historyCause, historyCause)}</span>
                                        </div>
                                        <div className={`${style.assess_content} pb-3`}>  
                                            <span className={style.assess_content_label}>Labels: </span> 
                                            <span className={style.assess_label}>{detailAssessment?.injuryType !== "" && detailAssessment?.injuryType !== null && detailAssessment?.injuryType !== "null" && detailAssessment?.injuryType}{detailAssessment?.bodyType !== "" && detailAssessment?.bodyType !== null && detailAssessment?.bodyType !== "null" && ', '}{detailAssessment?.bodyType !== "" && detailAssessment?.bodyType !== null && detailAssessment?.bodyType !== 'null' && detailAssessment?.bodyType} {(detailAssessment?.injuryType === "" || detailAssessment?.injuryType === "null" || detailAssessment?.injuryType === null) && (detailAssessment?.bodyType === "" || detailAssessment?.bodyType === "null" || detailAssessment?.bodyType === null) && 'None'}</span>
                                        </div>
                                        <div className={`${style.assess_content} pb-3 d-flex align-items-center justify-content-between`}> 
                                            <div className=''> 
                                                <span className={style.assess_content_label}>Wound Acquired: </span> 
                                                <span className={style.assess_label}>{detailAssessment?.woundAcquired} </span>
                                            </div>
                                            {/* <div className='mr-5'>
                                                <span className=''>{statusBadg[detailAssessment?.assessmentStage]}</span>
                                            </div> */}
                                        </div>
                                        <div className={`${style.assess_content}`}>  
                                            <span className={style.assess_content_label}>Classification: </span> 
                                            <span className={style.assess_label}>
                                            {detailAssessment?.classification?.woundClassification !== "unknown" ? (allNullCheck(detailAssessment?.classification?.woundClassification) ?                                  
                                                <span className={`${style.classifi_content}`}>
                                                    {woundClassificationOptions && woundClassificationOptions?.result?.length > 0 && woundClassificationOptions?.result?.map((data) => {
                                                        if (data.key === detailAssessment?.classification?.woundClassification) {
                                                            return data.value
                                                        }
                                                    })
                                                    }
                                                </span> : <span className={`${style.classifi_content}`}>{`Unknown`}</span>) :
                                                <span className={`${style.classifi_content}`}>{`Unknown`}</span>}
                                            </span>
                                        </div>
                                    </div>

                                    
                                </div>
                                <div className={`col-12 ${style.lastContent}`}>
                                    <div className={`${style.assess_content} pb-1 pt-1`}>
                                    <span className={style.assess_content_label}>Photo taken by:</span> <span className={style.assess_label_subDetail_labelout}>{detailAssessment?.photoTakenBy ? detailAssessment?.photoTakenBy : 'NA'}</span>  
                                    {` | `}
                                    <span className={style.assess_content_label}>Photo taken on:</span> <span className={style.assess_label_subDetail_labelout}>{detailAssessment?.identifiedDate ? fullMonthFormatDate(detailAssessment?.identifiedDate) : 'NA'}</span>
                                    </div>

                                    <div className={`${style.assess_content} pb-1`}>
                                    <span className={style.assess_content_label}>Assessed by:</span> <span className={style.assess_label_subDetail_labelout}>{detailAssessment?.assessedBy ? detailAssessment?.assessedBy : 'NA'}</span>
                                    {` | `}
                                    <span className={style.assess_content_label}>Last assessed: </span>
                                    <span className={style.assess_label_subDetail_labelout}>
                                        {detailAssessment?.lastAssessedDate ? fullMonthFormatDate(detailAssessment?.lastAssessedDate) : 'NA'}
                                    </span>                                    
                                    </div>

                                    <div className={`${style.assess_content} pb-1`}>
                                    <span className={style.assess_content_label}>Signed:</span> <span className={style.assess_label_subDetail_labelout}>{detailAssessment?.signedBy ? detailAssessment?.signedBy : 'NA'}</span>
                                        {` | `}
                                    <span className={style.assess_content_label}>Reviewed & Locked:</span> <span className={style.assess_label_subDetail_labelout}>{detailAssessment?.lockedBy ? detailAssessment?.lockedBy : 'NA'}</span>
                                    </div>
                                </div>

                            </div>            
                            }
                    
                        {/* )
                    })} */}
                </div>}
                
                {!allAssessmentState && undoChangeClick && <div className={`col-12 ${style.mergerWoundMain}`} onDrop={(e)=>{drop(e);setFirstContent(true);}} onDragOver={(e)=>{allowDrop(e);setFirstContent(true);}} id="div1">
                    {undoChangeValue && Array.isArray(undoChangeValue) && undoChangeValue?.map((itemValue, index)=>{
                        return(                     
                            <div key={index} className={!removeFlag ? `${style.wholeDrag}` : 'd-none'} draggable="true" onDragStart={(e)=>drag(e)} onDragOver={(e)=>allowDrop(e)} id={"drag1"}>
                                <div className={`col-12 ${style.woundTitle} d-flex py-3`}>
                                    <a href={`/patients/${patientData?.ne1Id}/assessment/${assessmentId}`}>
                                        {itemValue?.title}
                                    </a>
                                    <span className='ml-auto mr-4'>{statusBadg[detailAssessment?.assessmentStage]}</span>
                                    {/* <span className={`${style.adminPageYesBatch} ml-auto mr-4`}>{adminPageYes ? 'Parent' : 'Child'}</span> */}
                                    <i className={`fas`} style={{fontSize:'20px',color:'#787878',float:'right', marginTop:'-10px'}}>&#xf58e;</i>
                                </div>
                                <div className={`col-12 d-flex ${style.midContent} justify-content-center align-items-center`}>
                                    <div className='col-2 p-0'>
                                        <div className={`${style.woundAssessment_img_parent}`} draggable="false">
                                            <img src={itemValue?.picture} alt="wound" className="woundAssessment_wound_img" draggable="false"/>
                                        </div>
                                    </div>
                                    <div className='col-10'>
                                        <div className={`${style.assess_content} pb-3`}>  
                                            <span className={style.assess_content_label}>History/Cause: </span> 
                                            <span className={style.assess_label}>{getHistoryCauseText(itemValue?.historyCause, historyCause)}
                                            </span>
                                        </div>
                                        <div className={`${style.assess_content} pb-3`}>  
                                            <span className={style.assess_content_label}>Labels: </span> 
                                            <span className={style.assess_label}>{itemValue?.injuryType !== "" && itemValue?.injuryType !== null && itemValue?.injuryType !== "null" && itemValue?.injuryType}{itemValue?.bodyType !== "" && itemValue?.bodyType !== null && itemValue?.bodyType !== "null" && ', '}{itemValue?.bodyType !== "" && itemValue?.bodyType !== null && itemValue?.bodyType !== 'null' && itemValue?.bodyType} {(itemValue?.injuryType === "" || itemValue?.injuryType === "null" || itemValue?.injuryType === null) && (itemValue?.bodyType === "" || itemValue?.bodyType === "null" || itemValue?.bodyType === null) && 'None'} </span>
                                        </div>
                                        <div className={`${style.assess_content} pb-3 d-flex align-items-center justify-content-between`}> 
                                            <div className=''> 
                                                <span className={style.assess_content_label}>Wound Acquired: </span> 
                                                <span className={style.assess_label}>{detailAssessment?.woundAcquired} </span>
                                            </div>
                                            {/* <div className='mr-5'>
                                                <span className=''>{statusBadg[detailAssessment?.assessmentStage]}</span>
                                            </div> */}
                                        </div>
                                        <div className={`${style.assess_content}`}>  
                                            <span className={style.assess_content_label}>Classification: </span> 
                                            <span className={style.assess_label}>
                                            {itemValue?.classification?.woundClassification !== "unknown" ? (allNullCheck(itemValue?.classification?.woundClassification) ?                                  
                                                <span className={`${style.classifi_content}`}>
                                                    {woundClassificationOptions && woundClassificationOptions?.result?.length > 0 && woundClassificationOptions?.result?.map((data) => {
                                                        if (data.key === itemValue?.classification?.woundClassification) {
                                                            return data.value
                                                        }
                                                    })
                                                    }
                                                </span> : <span className={`${style.classifi_content}`}>{`Unknown`}</span>) :
                                                <span className={`${style.classifi_content}`}>{`Unknown`}</span>}
                                            </span>
                                        </div>
                                    </div>

                                    
                                </div>
                                <div className={`col-12 ${style.lastContent}`}>
                                    <div className={`${style.assess_content} pb-1 pt-1`}>
                                    <span className={style.assess_content_label}>Photo taken by:</span> <span className={style.assess_label_subDetail_labelout}>{itemValue?.photoTakenBy ? itemValue?.photoTakenBy : 'NA'}</span>  
                                    {` | `}
                                    <span className={style.assess_content_label}>Photo taken on:</span> <span className={style.assess_label_subDetail_labelout}>{itemValue?.identifiedDate ? fullMonthFormatDate(itemValue?.identifiedDate) : 'NA'}</span>
                                    </div>

                                    <div className={`${style.assess_content} pb-1`}>
                                    <span className={style.assess_content_label}>Assessed by:</span> <span className={style.assess_label_subDetail_labelout}>{itemValue?.assessedBy ? itemValue?.assessedBy : 'NA'}</span>
                                    {` | `}
                                    <span className={style.assess_content_label}>Last assessed: </span>
                                    <span className={style.assess_label_subDetail_labelout}>
                                        {itemValue?.lastAssessedDate ? fullMonthFormatDate(itemValue?.lastAssessedDate) : 'NA'}
                                    </span>                                    
                                    </div>

                                    <div className={`${style.assess_content} pb-1`}>
                                    <span className={style.assess_content_label}>Signed:</span> <span className={style.assess_label_subDetail_labelout}>{itemValue?.signedBy ? itemValue?.signedBy : 'NA'}</span>
                                        {` | `}
                                    <span className={style.assess_content_label}>Reviewed & Locked:</span> <span className={style.assess_label_subDetail_labelout}>{itemValue?.lockedBy ? itemValue?.lockedBy : 'NA'}</span>
                                    </div>
                                </div>

                            </div>            
                    
                    
                        )
                    })}
                </div>}


                {/* {!tinyDelyLeftAllAssessment ? <div className={`${'loader'} col-12`}><img src={Loader} alt="loading" /></div>:
                <div> */}
                {allAssessmentState && !undoChangeClickAllAssessment && <div className={`col-12 ${!movedSuccess ? style.mergerWoundMainAllAssessment : style.keepDivHeight}`} onDrop={(e)=>{drop(e);setFirstContent(false);}} onDragOver={(e)=>allowDrop(e)} id="div1">
                    {!tinyDelyLeftAllAssessment ? <div className={`${'loader'} col-12`}><img src={Loader} alt="loading" /></div>:
                    <div className={`${style.wholeDrag_Undo}`} draggable="true" onDragStart={(e)=>drag(e)} onDragOver={(e)=>allowDrop(e)} id={"drag1"}>
                        <div className=''>
                             <div className={`pl-4 ${style.sub_heading}`}>                                
                                <a href={`/patients/${patientData?.ne1Id}/assessment/${assessmentId}`}>{`${assessmentHistoryState?.woundTitle}`}</a>
                            </div>
                            <div className={`pl-4 pr-4 mb-2 mt-1 pt-1 ${style.admission_status}`}>History/Cause: {' '}
                                {getHistoryCauseText(assessmentHistoryState, historyCause)}
                            </div>
                            <div className={`pl-4 pr-4 mb-2 pb-1 mt-1 ${style.admission_status}`}>Admission Date: {fullMonthFormatDate(assessmentHistoryState?.admissionDate)}</div>
                        </div>
                        <div className=''>
                            <table className="w-100" cellPadding='0' cellSpacing='0'>
                            <thead>
                                <tr className={style.complete_th}>
                                <th>Wound</th>
                                <th>Record Type</th>
                                <th>Photo Taken On</th>
                                <th>Wound Progress</th>                             
                                </tr>
                            </thead>
                            {assessmentHistoryState && Array.isArray(assessmentHistoryState?.assessments) && assessmentHistoryState?.assessments?.map(item=>{
                                return(
                                    <tbody>
                                        <tr className={`${style.complete_td} mb-2`}>
                                            <td onClick={() => detaileView(item.id)}>
                                                {
                                                item.picture ? <img
                                                    src={item.picture}
                                                    alt="wound"
                                                    className={style.modal_image}
                                                /> :
                                                    <img src={LogoImage} alt="wound image" className={style.modal_image} />
                                                }
                                            </td>
                                            <td onClick={() => detaileView(item.id)}>
                                                {
                                                item.recordType ? <span className={`${style.recordTypeBatch}`}>{item.recordType}</span>
                                                :
                                                '-'
                                                }
                                            </td>
                                            <td onClick={() => detaileView(item.id)}>{format(new Date(item.identifiedDate), 'LLLL d, yyyy hh:mmaa')}</td>
                                            <td onClick={() => detaileView(item.id)}>
                                                {assessmentStageGetter(item.assessmentStage)}
                                            </td>
                                        </tr>
                                    </tbody>
                                )
                            })}
                            </table>
                        </div>
                    </div>
                    }
                </div>
                }
                {/* </div>} */}
                {allAssessmentState && undoChangeClickAllAssessment && <div className={`col-12 ${!movedSuccess ? style.mergerWoundMainAllAssessment : style.keepDivHeight}`} onDrop={(e)=>{drop(e);setFirstContent(false);}} onDragOver={(e)=>allowDrop(e)} id="div1">
                    {undoChangeValueAllAssessment && Array.isArray(undoChangeValueAllAssessment) && undoChangeValueAllAssessment?.map((itemValue, index)=>{
                        return(
                            <div key={index} className={!removeFlag ? `${style.wholeDrag}` : 'd-none'} draggable="true" onDragStart={(e)=>drag(e)} onDragOver={(e)=>allowDrop(e)} id={"drag1"}>
                                <div className=''>
                                    <div className={`pl-4 ${style.sub_heading}`}>                                
                                        <a href={`/patients/${patientData?.ne1Id}/assessment/${assessmentId}`}>{`${itemValue?.woundTitle}`}</a>
                                    </div>
                                    <div className={`pl-4 pr-4 mb-2 mt-1 pt-1 ${style.admission_status}`}>History/Cause: {' '}
                                        {getHistoryCauseText(itemValue, historyCause)}
                                    </div>
                                    <div className={`pl-4 pr-4 mb-2 pb-1 mt-1 ${style.admission_status}`}>Admission Date: {fullMonthFormatDate(itemValue?.admissionDate)}</div>
                                </div>
                                <div className=''>
                                    <table className="w-100" cellPadding='0' cellSpacing='0'>
                                    <thead>
                                        <tr className={style.complete_th}>
                                        <th>Wound</th>
                                        <th>Record Type</th>
                                        <th>Photo Taken On</th>
                                        <th>Wound Progress</th>                             
                                        </tr>
                                    </thead>
                                    {itemValue && Array.isArray(itemValue?.assessments) && itemValue?.assessments?.map(item=>{
                                        return(
                                            <tbody>
                                                <tr className={`${style.complete_td} mb-2`}>
                                                    <td onClick={() => detaileView(item.id)}>
                                                        {
                                                        item.picture ? <img
                                                            src={item.picture}
                                                            alt="wound"
                                                            className={style.modal_image}
                                                        /> :
                                                            <img src={LogoImage} alt="wound image" className={style.modal_image} />
                                                        }
                                                    </td>
                                                    <td onClick={() => detaileView(item.id)}>
                                                        {
                                                        item.recordType ? <span className={`${style.recordTypeBatch}`}>{item.recordType}</span>
                                                        :
                                                        '-'
                                                        }
                                                    </td>
                                                    <td onClick={() => detaileView(item.id)}>{format(new Date(item.identifiedDate), 'LLLL d, yyyy hh:mmaa')}</td>
                                                    <td onClick={() => detaileView(item.id)}>
                                                        {assessmentStageGetter(item.assessmentStage)}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        )
                                    })}
                                    </table>
                                </div>
                            </div>
                        )})}
                </div>
                }
            </div>

            <div className={`col-6 ${style.mergeListSection} ${leaveHover && !movedSuccess && dropHereState && style.mergeListSectionPaddingHeight}`}>
            <div className='col-12 d-flex align-items-start justify-content-between px-0 pt-1 pb-2'>
                <h3>Find the patient by MRN # to transfer the wound to</h3>   
            </div>
            {!tinyDelay ? <div className={`${'loader'} col-12`}><img src={Loader} alt="loading" /></div>:
            <div>  
            <div className='col-12 pl-0 pr-2 pt-1 pb-3 d-flex justify-content-between'>
                <div className={`${style.searchBox} col-5`}>
                    <span className={`${style.searchIcon}`}>
                        <img src={searchIcon} alt="search icon" />
                    </span>
                    <input 
                        id="searchurlInput" 
                        type="text" 
                        placeholder='#MRN' 
                        className={`searchurlInput ${style.searchInput}`} 
                        onKeyUp={(e) => {
                            if (e.key === 'Enter') {
                                getSearchValue(e.target.value);
                            }
                        }}
                        onChange={(e)=>getShowClearX(e)}
                        defaultValue={searchKey}
                    /> 
                    {showClearX && <span 
                    id="clear_icon"
                    className={`${style.x_icon}`}
                    onClick={(e)=>ClearData(
                        document.getElementById('searchurlInput').value
                        )}                          
                    >
                    <i className="fa fa-times" style={{color : "#000"}} aria-hidden="true"></i>
                </span>}
                </div>                
                <SelectBox
                    id={"facility"}
                    name={"facilityFilter"}
                    classes={{ column: "col-7 px-0", labelClassName: `col-3 col-form-label p-0 `, inputColumn: `col-12 p-0  ${style.select_wrapper}`, inputClassName: `form-control ${style.basic_select}` }}
                    optionValue={Array.isArray(facilityNumberOption)?facilityNumberOption:[]}
                            // defaultValue = {selectedFacility}
                    defaultValue={patientListLastVal?.selectedFacility?patientListLastVal?.selectedFacility:selectedFacility}
                    onChange={(e) => facilityListView(e.target.value)}
                    placeholder={'Facility/Location'}
                />
            </div>  
            <div className={transferData?.data?.patients?.length > 0 ? `${style.mergeListWhole} col-12` : 'd-none'}>
            {
                transferData && Array.isArray(transferData?.data?.patients) && transferData?.data?.patients.map((item,index)=>{
            //    transferData && Array.isArray(transferData.patients) && transferData.patients.map(data=>data.patients.map((item,index)=>{
                    return(
                        <div key={index} className={`${style.mergeList} ${onHoverList===index && leaveHover && dropHereState ? 'pb-4' : 'pb-0'} ${movedSuccess && onHoverList===index && !leaveHover && 'pb-3'}`}>
                            <div className='col-12 py-0 px-0' onDragEnter={(e)=>hoverRightList(e, index)} id="div2">                                
                                
                            <div className={`${style.patientCardMain}`} ref={leaveDropAction}>
                                <div className={`col-12 ${style.patient_details_blk_scroll}`}>
                                    <div className={`${style.patient_image} mx-3`}>
                                        <a href={`/admin/patients/${item.ne1Id}`} target="_self">
                                            <img src={item?.profilePicture || pictureIcon} alt={`${item?.title}`}/>                    
                                        </a>
                                    </div>
                                    <div className={`${style.patient_details}`}>
                                        <div className='d-flex align-items-center pb-2'>
                                            <div className={'d-flex align-items-center'} >
                                                <a href={`/admin/patients/${item.ne1Id}`} target="_self" className={'d-flex align-items-center'}>
                                                    <h4 className="pr-1 mb-0">{`${item?.firstName} ${item?.lastName}`}</h4>
                                                    {/* <h4 className="pr-1 mb-0">{item?.title}</h4> */}
                                                </a>
                                            </div>
                                            <div className={`verticalCode  ${style.vertical_Code}`}>
                                            </div>    
                                            <p className={`${style.labelSize} pt-1`}><span>{item?.age}</span></p>
                                            <div className={`verticalCode  ${style.vertical_Code}`}>
                                            </div>
                                            <p className={`${style.labelSize} pt-1`}><span>{item.gender}</span></p>                        
                                            <div className={'mx-4 text-center'}>
                                                <Button
                                                    type={"button"}
                                                    value={"Diabetic"}
                                                    classes={{ className: (item?.moreInfo?.diabetic === "1" || item?.moreInfo?.diabetic === 1) ?  `btn ${style.btn_custom_with_diabetic}` : 'd-none' }}
                                                    id="diabetic"
                                                />
                                            </div>                       
                                        </div>
                                        <div className='d-flex align-items-center'>
                                            <p className={`${style.labelSize}`}><label>MRN #:</label><span>{item?.mrn !== null ? item?.mrn : "-"}</span></p>
                                            <div className={`verticalCode  ${style.vertical_Code_one}`}>
                                            </div>
                                            <p className={`${style.labelSize}`}><label>DOB:</label><span>{dateOfBirthDate(item?.dob)}</span></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>

                            {onHoverList===index && leaveHover && !movedSuccess && dropHereState ?                             
                                <div className={`${style.mergeListHover} mx-auto text-center`} onDrop={(e)=>drop(e, item?.ne1Id)} onDragOver={(e)=>allowDrop(e, item?.ne1Id)}>
                                    <div className={`${style.mergeListHoverPara}`}>
                                        <p>Drop here...</p>
                                    </div> 
                                    
                                </div>
                                : ""
                            }

                            {movedSuccess && onHoverList===index && !leaveHover && !giveConfirmation && <div className='d-flex justify-content-center pt-2' onDragLeave={(e)=>hoverLeaveRIghtList(index)}>
                                <div className="text-center py-3">                                                               
                                    {/* Cancel button  */}
                                    <Button
                                    classes={{ className: `btn ${style.btn_custom} ${style.btn_small_cancel} ${style.btn_small_cancel_color} ${style.btn_small_cancel_bgcolor} mr-5`}}
                                    // id={CANCEL_ID}
                                    name="cancel"
                                    onClick={(e)=>{!allAssessmentState ? clickUndoChange(e) : clickUndoChangeAllAssessment(e)}}
                                    >
                                    {"Undo"}
                                    </Button>
                                    {/* Save Button */}
                                    <Button
                                    classes={{ className: `btn ${style.btn_custom} ${style.btn_small} ${style.btn_small_cancel_color}` }}
                                    type="submit"
                                    // id={SUBMIT_ID}
                                    onClick={(e)=>clickConfirmChange(e)}
                                    >
                                    {"Confirm"}
                                    </Button>
                                 </div>                         
                            </div>}

                            {giveConfirmation && !navigatePmtScreen && movedSuccess && onHoverList===index && !leaveHover &&
                                <div className={`${style.mergeWoundSuccess} text-center mr-3 ml-2 pt-3`}>                                    
                                    <p><span><i className="fa fa-check" aria-hidden="true" style={{color:"rgb(0, 173, 47)",paddingTop:"8px", paddingRight:'10px'}}></i></span> Wound transferred successfully</p>                                
                                </div>
                            }
                        </div>
                    )
                })
            }
            </div>
            <div className='col-12'>
             {(!noPage) && (Array.isArray(transferData?.data?.patients)) && (transferData?.data?.patients?.length > 0) && <Pagination
                activePage={activePage}
                itemsCountPerPage={transferData?.data?.metadata ? transferData?.data?.metadata.limit : 50}
                totalItemsCount={transferData?.data?.metadata ? transferData?.data?.metadata.total : 0}
                getActivePage={getActivePage}
                formularyView={false}
            />}
            </div> 
            {(transferData?.data?.patients?.length < 1 || transferData?.data?.patients === undefined) && <div className='text-center col-12 py-3'>
                <h6 className='text-center'>No records found</h6>
                </div>}
            </div>}  
                         
                    
            </div>
            {/* <div className='col-6'></div>
            <div className='col-6'>
            {(Array.isArray(transferData.patients)) && (transferData.patients.length > 0) && <Pagination
                activePage={activePage}
                itemsCountPerPage={transferData.metadata ? transferData.metadata.limit : 50}
                totalItemsCount={transferData.metadata ? transferData.metadata.total : 0}
                getActivePage={getActivePage}
                // formularyView={formularyView}
            />} 
            </div> */}
            </div>
        </div>
    )
}

export default TransferWoundAssessment